import { registerMessages } from "../../i18n/runtime";
import { importersEn } from "./messages.en";
import { importersEs } from "./messages.es";

registerMessages("en", importersEn);
registerMessages("es", importersEs);
